import { LucideIcon } from "lucide-react";

interface InfoCardProps {
  icon?: LucideIcon;
  title: string;
  description: string;
  variant?: "info" | "success" | "warning" | "tip";
}

const variantMap: Record<NonNullable<InfoCardProps["variant"]>, "info" | "tip" | "warning"> = {
  info: "info",
  success: "tip",
  warning: "warning",
  tip: "tip",
};

export default function InfoCard({
  icon: Icon,
  title,
  description,
  variant = "info",
}: InfoCardProps) {
  return (
    <div className={`info-banner ${variantMap[variant]}`}>
      <span className="ib-icon">
        {Icon ? <Icon size={16} /> : "i"}
      </span>
      <span>
        <strong>{title}</strong> {description}
      </span>
    </div>
  );
}
